"use strict";

exports.__esModule = true;
exports.FilterSearch = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _SearchInput = require("../SearchInput");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function setFilter(_ref, value) {
  var setFiltered = _ref.setFiltered,
    filtered = _ref.filtered,
    accessor = _ref.accessor;
  setFiltered(filtered.filter(function (filter) {
    return filter.id !== accessor;
  }).concat({
    id: accessor,
    value: value
  }));
}
var FilterSearch = exports.FilterSearch = function FilterSearch(props) {
  var accessor = props.accessor,
    filtered = props.filtered,
    setFiltered = props.setFiltered;
  var filteredColumnValue = filtered.find(function (filter) {
    return filter.id === accessor;
  });
  return /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
    shouldDismissPopover: false,
    text: /*#__PURE__*/_react["default"].createElement(_SearchInput.DebouncedSearchInput, {
      value: filteredColumnValue && typeof filteredColumnValue.value === "string" ? filteredColumnValue.value : "",
      debounceDuration: 200,
      onChange: function onChange(val) {
        setFilter({
          accessor: accessor,
          filtered: filtered,
          setFiltered: setFiltered
        }, val);
      }
    })
  });
};